<app-dashboard-header></app-dashboard-header>

<div class="organisations-content">
  <h1 class="page-title">Organisations</h1>
  
  <mat-card>
    <div class="card-header">
      <h2>Manage Organisations</h2>
      <button mat-flat-button class="action-button accent" (click)="openAddDialog()">
        <mat-icon>add</mat-icon>
        Add Organisation
      </button>
    </div>
    
    <mat-progress-spinner *ngIf="loading" mode="indeterminate" diameter="40"></mat-progress-spinner>

    <div *ngIf="error" class="error-message">
      {{ error }}
    </div>

    <div *ngIf="!loading && organisations.length > 0" class="table-container">
      <table mat-table [dataSource]="organisations" style="width: 100%;">

        <!-- ID Column -->
        <ng-container matColumnDef="id">
          <th mat-header-cell *matHeaderCellDef>ID</th>
          <td mat-cell *matCellDef="let org">{{ org.id }}</td>
        </ng-container>

        <!-- Name Column -->
        <ng-container matColumnDef="name">
          <th mat-header-cell *matHeaderCellDef>Name</th>
          <td mat-cell *matCellDef="let org">
            {{ org.name }}
          </td>
        </ng-container>

        <!-- Type Column -->
        <ng-container matColumnDef="type">
          <th mat-header-cell *matHeaderCellDef>Type</th>
          <td mat-cell *matCellDef="let org">
            {{ org.type?.name || '-' }}
          </td>
        </ng-container>

        <!-- Actions Column -->
        <ng-container matColumnDef="actions">
          <th mat-header-cell *matHeaderCellDef style="width: 240px;">Actions</th>
          <td mat-cell *matCellDef="let org">
            <button
              mat-icon-button
              color="accent"
              [matTooltip]="org.lastSyncAt ? 'Last sync: ' + (org.lastSyncAt | date:'short') : 'Sync resource types'"
              (click)="$event.stopPropagation(); syncOrganisation(org)"
              [disabled]="isSyncing(org)">
              <mat-icon [class.spinning]="isSyncing(org)">sync</mat-icon>
            </button>
            <button mat-icon-button color="primary" matTooltip="Edit" (click)="$event.stopPropagation(); openEditDialog(org)">
              <mat-icon>edit</mat-icon>
            </button>
            <button mat-icon-button color="warn" matTooltip="Delete" (click)="$event.stopPropagation(); deleteOrganisation(org)">
              <mat-icon>delete</mat-icon>
            </button>
          </td>
        </ng-container>

        <tr mat-header-row *matHeaderRowDef="displayedColumns" class="table-header-row"></tr>
        <tr mat-row *matRowDef="let row; columns: displayedColumns;" 
            (click)="openEditDialog(row)"
            class="clickable-row"></tr>
      </table>
    </div>
    <div *ngIf="!loading && organisations.length === 0" class="no-orgs">
      <mat-icon>info</mat-icon>
      <p>No organisations found. Click the "Add Organisation" button to create your first organisation.</p>
    </div>
  </mat-card>
</div>

<app-dashboard-footer></app-dashboard-footer>
